"use client"
import React from 'react'

// 移动端详情页截图/视频展示（客户端组件：屏蔽右键下载 + 禁拖拽；视频去控件下载按钮）
export default function ShowcaseMedia({ video, thumbnail, alt }: { video?: string; thumbnail: string; alt: string }) {
    const block = (e: React.SyntheticEvent) => e.preventDefault()
    if (video) {
        return (
            <video className="w-full h-auto" controls preload="metadata" poster={thumbnail}
                controlsList="nodownload" onContextMenu={block}>
                <source src={video} type="video/mp4" />
            </video>
        )
    }
    return (
        <img src={thumbnail} alt={alt} loading="lazy" className="w-full h-auto"
            draggable={false} onContextMenu={block} />
    )
}
